// src/ItemFormModal.js

import React, { useState } from 'react';

function ItemFormModal({ item, categories, onSave, onClose }) {
    const [formData, setFormData] = useState(
        item || {
            name: '',
            description: '',
            imageUrl: '',
            amazonLink: '',
            categoryId: categories[0]?.id || '',
        }
    );

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-[100]">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-2xl p-6">
                <h2 className="text-xl font-bold mb-4">{item ? 'Edit Item' : 'Add New Item'}</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Category</label>
                        <select name="categoryId" value={formData.categoryId} onChange={handleChange} className="w-full p-2 mt-1 border rounded-md dark:bg-gray-700 dark:border-gray-600" required>
                            {categories.map(cat => (
                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Item Name</label>
                        <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full p-2 mt-1 border rounded-md dark:bg-gray-700 dark:border-gray-600" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Description</label>
                        <textarea name="description" value={formData.description} onChange={handleChange} rows="3" className="w-full p-2 mt-1 border rounded-md dark:bg-gray-700 dark:border-gray-600" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Image URL</label>
                        <input type="url" name="imageUrl" value={formData.imageUrl} onChange={handleChange} className="w-full p-2 mt-1 border rounded-md dark:bg-gray-700 dark:border-gray-600" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Amazon Affiliate Link</label>
                        <input type="url" name="amazonLink" value={formData.amazonLink} onChange={handleChange} className="w-full p-2 mt-1 border rounded-md dark:bg-gray-700 dark:border-gray-600" required />
                    </div>
                    <div className="flex justify-end gap-4 pt-4">
                        <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 dark:bg-gray-600 rounded-md hover:bg-gray-300">
                            Cancel
                        </button>
                        <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">
                            Save Item
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ItemFormModal;